import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import differenceInYears from "date-fns/differenceInYears";
import { RegexFields } from "../../../../../../../constants/utils/regexFields";

import { DateWithModal } from "../../../../../../../_common/dateWithModal";
import RelocationChild from "../../../../../../../constants/models/events/relocationChild";
import { updateRelocationDeclaration } from "../../../../../../../actions/events-api";
import * as loadings from "../../../../../../../constants/loadings/relocationDeclaration";
import $ from "jquery";

export const FormFamilyEnv = ({ relocationDeclaration, userId, isLoading, setEditMode }) => {
	const form = useRef(null);
	const dispatch = useDispatch();

	const today = new Date();

	const initialState = {
		items: relocationDeclaration?.children || [],
		showNewChildForm: false,
		newChildForm: { name: undefined, age: undefined, birthDate: undefined, isHandicaped: false, isDependent: false, isStudent: false, isEmployed: false },
	};

	const [childrenState, setChildrenState] = useState(initialState);

	useEffect(() => {
		if (childrenState.newChildForm.birthDate) {
			setChildrenState({ ...childrenState, newChildForm: { ...childrenState.newChildForm, age: differenceInYears(today, new Date(childrenState.newChildForm.birthDate)) } });
		}
	}, [childrenState.newChildForm.birthDate]);

	return (
		<div className="card">
			<div className="card-content">
				<div className="card-body py-0">
					<div className="flex-row align-items-center mb-2 border-bottom pb-2 border-light">
						<p className="o-60 pr-3 my-auto">Modifier les informations qui ne sont pas à jour.</p>
						{/* { childrenState.showNewChildForm === true ? '' : */}
						<button
							type="button"
							className={"btn btn-alert-info ml-auto border-none" + (childrenState.showNewChildForm === true ? " disabled" : "")}
							disabled={childrenState.showNewChildForm === true ? "true" : ""}
							onClick={(e) => {
								e.preventDefault();
								setChildrenState({ ...childrenState, showNewChildForm: true });
							}}>
							Ajouter <span className="d-none d-lg-inline-block">un enfant</span>
						</button>
						{/* } */}
					</div>
					{childrenState.showNewChildForm === true ? (
						<form className="flex-column card p-3 bg-light flex-fill order-lg-last mb-xs mt-n2" ref={form}>
							<div className="form-row">
								<div className="form-group col-12 col-lg-4">
									<label className="h6 font-weight-bolder my-auto" htmlFor="nom">
										Nom *
									</label>
									<input
										required
										type="text"
										className="form-control"
										id="nom"
										defaultValue={childrenState.newChildForm.name}
										onChange={(e) => {
											e.preventDefault();
											setChildrenState({ ...childrenState, newChildForm: { ...childrenState.newChildForm, name: e.target.value } });
										}}
										pattern={RegexFields.nameWithoutNumbers}
									/>
								</div>
								<div className="form-group col-12 col-lg-4">
									<label className="h6 font-weight-bolder my-auto" htmlFor="naissance">
										Date de naissance *
									</label>
									<DateWithModal isRequired={true} selectedDate={childrenState.newChildForm.birthDate} setSelectedDate={(d) => setChildrenState({ ...childrenState, newChildForm: { ...childrenState.newChildForm, birthDate: d } })} />
								</div>
								<div className="form-group col-12 col-lg-4">
									<h5 className="h6 font-weight-bolder">Handicapé(e)</h5>

									<select className="custom-select" id="isHandicaped" tabIndex={-98} onChange={() => setChildrenState({ ...childrenState, newChildForm: { ...childrenState.newChildForm, isHandicaped: !childrenState.newChildForm.isHandicaped } })}>
										<option value={childrenState.newChildForm.isHandicaped === false}>Non</option>
										<option value={childrenState.newChildForm.isHandicaped === true}>Oui</option>
									</select>
								</div>
								<div className="form-group col-12 col-lg-4">
									<h5 className="h6 font-weight-bolder">A charge</h5>

									<select className="custom-select" id="isDependent" tabIndex={-98} onChange={() => setChildrenState({ ...childrenState, newChildForm: { ...childrenState.newChildForm, isDependent: !childrenState.newChildForm.isDependent } })}>
										<option value={childrenState.newChildForm.isDependent === false}>Non</option>
										<option value={childrenState.newChildForm.isDependent === true}>Oui</option>
									</select>
								</div>
								<div className="form-group col-12 col-lg-4">
									<h5 className="h6 font-weight-bolder">Étudiant(e)</h5>

									<select className="custom-select" id="isStudent" tabIndex={-98} onChange={() => setChildrenState({ ...childrenState, newChildForm: { ...childrenState.newChildForm, isStudent: !childrenState.newChildForm.isStudent } })}>
										<option value={childrenState.newChildForm.isStudent === false}>Non</option>
										<option value={childrenState.newChildForm.isStudent === true}>Oui</option>
									</select>
								</div>
								<div className="form-group col-12 col-lg-4">
									<h5 className="h6 font-weight-bolder">Salarié(e)</h5>

									<select className="custom-select" id="isEmployed" tabIndex={-98} onChange={() => setChildrenState({ ...childrenState, newChildForm: { ...childrenState.newChildForm, isEmployed: !childrenState.newChildForm.isEmployed } })}>
										<option value={childrenState.newChildForm.isEmployed === false}>Non</option>
										<option value={childrenState.newChildForm.isEmployed === true}>Oui</option>
									</select>
								</div>
							</div>
							<div className="form-footer">
								<button
									type="button"
									className="btn btn-info mr-2"
									onClick={(e) => {
										e.preventDefault();
										form.current.classList.add("was-validated");
										if (form.current.checkValidity()) {
											setChildrenState({
												...childrenState,
												items: childrenState.items.concat(new RelocationChild(childrenState.newChildForm)),
												showNewChildForm: false,
												newChildForm: { name: undefined, age: undefined, birthDate: undefined, isHandicaped: false, isDependent: false, isStudent: false, isEmployed: false },
											});
										}
									}}>
									Ajouter
								</button>
								<button
									type="button"
									className="btn btn-white-faded"
									onClick={(e) => {
										e.preventDefault();
										setChildrenState({ ...childrenState, showNewChildForm: false, newChildForm: { name: undefined, birthDate: undefined, isHandicaped: false, isDependent: false, isStudent: false, isEmployed: false } });
									}}>
									Annuler
								</button>
							</div>
						</form>
					) : (
						""
					)}
					{childrenState.items.length > 0 ? (
						<div className="grid grid-md-tight grid-lg-min g-2">
							{childrenState.items.map((child, index) => {
								return (
									<div className={"card p-2 border border-light flex-row" + (childrenState.items.length > 1 ? " mt-2" : "")} key={index}>
										<span className="block pl-1 pr-3">
											<p className="h5 mb-1 mt-auto">Nom: {child.name}</p>
											<p className="h6 o-60 mb-auto">Âge: {differenceInYears(today, new Date(child.birthDate))}</p>
											<p className="h6 o-60 mb-auto">Handicapé(e): {child.isHandicaped ? "Oui" : "Non"}</p>
											<p className="h6 o-60 mb-auto">A charge: {child.isDependent ? "Oui" : "Non"}</p>
											<p className="h6 o-60 mb-auto">Étudiant(e): {child.isStudent ? "Oui" : "Non"}</p>
											<p className="h6 o-60 mb-auto">Salarié(e): {child.isEmployed ? "Oui" : "Non"}</p>
										</span>
										<button
											className="btn btn-sm btn-icon px-xs btn-alert-danger border-none ml-auto"
											onClick={(e) => {
												e.preventDefault();
												setChildrenState({ ...childrenState, items: childrenState.items.filter((c) => c !== child), showNewChildForm: false, newChildForm: { name: undefined, birthDate: undefined, isHandicaped: false, isDependent: false, isStudent: false, isEmployed: false } });
											}}>
											<i className="eva eva-trash-outline"></i>
										</button>
									</div>
								);
							})}
						</div>
					) : (
						""
					)}
				</div>
				<div className="card-footer">
					<button
						type="button"
						className="btn btn-light mr-2"
						onClick={(e) => {
							e.preventDefault();
							setChildrenState(initialState);
							setEditMode(false);
						}}>
						Annuler
					</button>
					{childrenState.showNewChildForm === true ? (
						<button type="button" className="btn btn-info disabled">
							Sauvegarder
						</button>
					) : isLoading.includes(loadings.UPDATING_RELOCATION_DECLARATION) ? (
						<button type="button" className="btn btn-info loading-btn show">
							<div className="loading loading-spinner spinner-border spinner-border-sm mr-2"></div>Sauvegarder
						</button>
					) : (
						<button
							type="button"
							className="btn btn-info"
							onClick={(e) => {
								e.preventDefault();
								dispatch(
									updateRelocationDeclaration(userId, {
										...relocationDeclaration,
										children: childrenState.items,
									})
								).then(() => setEditMode(false));
							}}>
							Sauvegarder
						</button>
					)}
				</div>
			</div>
		</div>
	);
};
